import ActionTypes from "../constants/ActionTypes";
import BASE_URL from "../constants/Api";
import axiosInstance from "../helpers/refreshTokenMiddleware";

/* =========================================================
 * 管理者マスタ一覧取得 (User List Fetch)
 * ========================================================= */
export const fetchUserListRequest = () => ({
  type: ActionTypes.FETCH_USER_LIST_REQUEST,
});

export const fetchUserListSuccess = (data_list, all_data_count) => ({
  type: ActionTypes.FETCH_USER_LIST_SUCCESS,
  payload: { data_list, all_data_count },
});

export const fetchUserListFailure = (error) => ({
  type: ActionTypes.FETCH_USER_LIST_FAILURE,
  payload: error,
  error: true,
});

export const fetchUserList = () => async (dispatch) => {
  dispatch(fetchUserListRequest());

  try {
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
      window.location.href = "/login";
      return;
    }

    const response = await axiosInstance.get(`${BASE_URL}?path=user&type=get-list-data`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    const { data_list, all_data_count } = response.data.respons;
    dispatch(fetchUserListSuccess(data_list, all_data_count ));

  } catch (error) {
    dispatch(fetchUserListFailure(error.message));
  }
};
